var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { createPaginationArray } from "./utils/functions";
import { Button } from "../Button";
// styles
import "./pagination.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-pagination",
    disabled: false,
    pagesToShowCloseTheCurrent: 1,
};
const Pagination = (_a) => {
    var { pages, currentPage, setCurrentPage, setNextPage, setPrevPage, disabled, pagesToShowCloseTheCurrent, className, nextButtonIcon, prevButtonIcon, outlined, currentPageButtonStyle } = _a, rest = __rest(_a, ["pages", "currentPage", "setCurrentPage", "setNextPage", "setPrevPage", "disabled", "pagesToShowCloseTheCurrent", "className", "nextButtonIcon", "prevButtonIcon", "outlined", "currentPageButtonStyle"]);
    const classList = classNames("tecma-pagination", disabled, className);
    // TODO: the pagination array could be handle better
    const paginationArray = createPaginationArray(pages, currentPage, pagesToShowCloseTheCurrent);
    return (_jsxs("div", Object.assign({ className: classList }, rest, { children: [_jsx(Button, { iconName: prevButtonIcon || "arrow-left", onClick: setPrevPage, disabled: currentPage === 1 || disabled, color: "transparent" }), paginationArray.map((page) => (_jsx(Button, Object.assign({ onClick: () => setCurrentPage(page), className: classNames("pagination-page", {
                    "is-selected": currentPage === page,
                    "is-not-page": page === "...",
                }), disabled: disabled, color: "transparent", outlined: currentPage === page && outlined }, currentPageButtonStyle, { children: page })))), _jsx(Button, { iconName: nextButtonIcon || "arrow-right", onClick: setNextPage, disabled: currentPage === pages || disabled, color: "transparent" })] })));
};
Pagination.defaultProps = defaultProps;
export default React.memo(Pagination);
